import { Link as RouterLink } from 'react-router-dom';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Card, Link, Container, Typography, Button, Grid } from '@material-ui/core';

import { SelfRegForm } from '../components/authentication/selfregister';
import AuthLayout from '../layouts/AuthLayout';

import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import AuthSocial from '../components/authentication/AuthSocial';
import SelfRegSign from '../components/authentication/selfregister/SelfRegSign';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function SelfRegRedirect() {
  const handleRedirect = () => {
    window.location.replace('https://www.zimta.org.zw');
  };
  return (
    <RootStyle title="Register | ZIMTA">
      {/* <AuthLayout>
        Already have an account? &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/login">
          Login
        </Link>
      </AuthLayout> */}

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Registration Complete
          </Typography>
          <img alt="register" src="/static/illustrations/illustration_register.png" />
        </SectionStyle>
      </MHidden>

      <Container>
        {/* <ContentStyle> */}
        <Box sx={{ mb: 5, mt: 12 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Hooray we are done!!
          </Typography>
          <Typography
            variant="h6"
            align="center"
            mt="8"
            sx={{ display: 'flex', justifyContent: 'center' }}
            gutterBottom
          >
            Thank you for registering with ZIMTA. We will communicate with yourselves within the
            next 2 days while we verify provided details. Please contact us on (+263) 78 278 2788 in
            the meantime or email us on info@zimta.co.zw for any questions or information.
          </Typography>
        </Box>
        <Grid container margin={2} direction="row" justifyContent="center" alignItems="center">
          <Button
            align="center"
            type="button"
            variant="contained"
            sx={{
              height: '50px',
              width: '200px',
              ml: '4px',
              color: 'white',
              backgroundColor: '#000000'
            }}
            onClick={handleRedirect}
          >
            Return to Main Website
          </Button>
        </Grid>
        <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mt: 3 }}>
          By registering, I agree to ZIMTA&nbsp;
          <Link underline="always" sx={{ color: 'text.primary' }}>
            Terms of Service
          </Link>
          &nbsp;and&nbsp;
          <Link underline="always" sx={{ color: 'text.primary' }}>
            Privacy Policy
          </Link>
          .
        </Typography>
      </Container>
    </RootStyle>
  );
}
